import { render, staticRenderFns } from "./ModalDadosFornecedor.vue?vue&type=template&id=50979a01&"
import script from "./ModalDadosFornecedor.vue?vue&type=script&lang=js&"
export * from "./ModalDadosFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports